export const faqItems = [
  {
    question: '继母应该如何与青春期的继子女建立关系？',
    answer: '与青春期继子女建立关系，关键是保持耐心和一致性。不要急于求成，从日常小事入手——尊重他们的空间、在需要时提供支持但不强迫介入、通过间接沟通如短信和共同活动来建立连接。重要的是让孩子感受到你是一个稳定的存在，而不是一个急于替代他们母亲的人。',
  },
  {
    question: '继姐之间的竞争和嫉妒该如何处理？',
    answer: '首先要认识到竞争和嫉妒是正常的情绪反应，不必为此感到羞愧。其次，可以通过以下方式化解：1）坦诚沟通感受，使用第一人称表达；2）寻找共同的兴趣和合作机会；3）父母要公平对待，避免比较；4）建立属于你们自己的独特仪式和回忆。',
  },
  {
    question: '重组家庭需要多长时间才能真正融合？',
    answer: '研究显示，重组家庭完全融合平均需要2到5年时间。这是一个渐进的过程，不是线性发展的。第一年通常是建立基本规则和边界的时期；第二到第三年是深度磨合期；三到五年后，大多数家庭成员会找到相对稳定的相处模式。但每个家庭的情况都不同，重要的是保持耐心和持续的努力。',
  },
  {
    question: '如何在重组家庭中保护好夫妻关系？',
    answer: '夫妻关系是重组家庭的基石。建议：1）每周保证至少一次夫妻独处时间；2）在子女面前呈现统一的教养阵线；3）定期进行关系状态沟通，及时处理积累的情绪；4）不要让孩子的问题完全占据你们的生活空间；5）必要时寻求伴侣咨询的专业帮助。',
  },
  {
    question: '继母在家庭中应该扮演什么样的管教角色？',
    answer: '在初期阶段，建议继母以支持者而非管教者的身份出现。让生物学父母主导重大纪律决策，继母则专注于建立情感连接和支持伴侣的管教决定。随着信任的建立和关系的深化，可以逐步承担更多的共同管教责任，但这个过程需要循序渐进，通常需要一年以上的时间。',
  },
];